import { withStyles } from '@material-ui/core/styles';
import Select from './Select';
import styles from './Select.styles';

export default withStyles(styles)(Select);
